var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var domain;
        (function (domain) {
            var UserInfo = (function () {
                function UserInfo(UserId, PersonId, UserName, FirstName, LastName, DisplayAsName,  State, PostalCode, Email, Fax, Creator, CreatedDate, CreatedDateString, LastModifiedBy, LastUpdated, LastUpdatedString, Active, Deleted, Roles, JCCCC) {
                    this.UserId = UserId;
                    this.PersonId = PersonId;
                    this.UserName = UserName;
                    this.FirstName = FirstName;
                    this.LastName = LastName;
                    this.DisplayAsName = DisplayAsName;
                    this.State = State;
                    this.Email = Email;
                    this.Fax = Fax;
                    this.Creator = Creator;
                    this.CreatedDate = CreatedDate;
                    this.CreatedDateString = CreatedDateString;
                    this.LastModifiedBy = LastModifiedBy;
                    this.LastUpdated = LastUpdated;
                    this.LastUpdatedString = LastUpdatedString;
                    this.Active = Active;
                    this.Deleted = Deleted;
                    this.Roles = Roles;
                    this.UserId = UserId;
                    this.PersonId = PersonId;
                    this.UserName = UserName;
                    this.FirstName = FirstName;
                    this.LastName = LastName;
                    this.JCCCC = JCCCC,
                    this.Roles = Roles;
                    this.DisplayAsName = DisplayAsName;
                    this.FullName = this.LastName + ', ' + this.FirstName;
                    this.State = State;
                    this.Email = Email;
                    this.Fax = Fax;
                    this.Creator = Creator;
                    this.CreatedDate = CreatedDate;
                    this.CreatedDateString = CreatedDateString;
                    this.LastModifiedBy = LastModifiedBy;
                    this.LastUpdated = LastUpdated;
                    this.LastUpdatedString = LastUpdatedString;
                    this.Active = Active || true;
                    this.Deleted = Deleted || false;
                }
                return UserInfo;
            })();
            domain.UserInfo = UserInfo;
        })(domain = app.domain || (app.domain = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
